import { render, staticRenderFns } from "./SendOtpView.vue?vue&type=template&id=00cfb16c"
import script from "./SendOtpView.vue?vue&type=script&lang=js"
export * from "./SendOtpView.vue?vue&type=script&lang=js"
import style0 from "./SendOtpView.vue?vue&type=style&index=0&id=00cfb16c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports